<template>
  <div id="roleWrapper">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <Select v-model="selNowEnterId" placeholder="请选择企业名称" style="width:300px" @on-change="enterpListChange">
          <Option v-for="(item,index) in getEnterpriseList" :key="index" :value="item.dept_id">
            {{item.dept_cn_name}}
          </Option>
        </Select>
        &nbsp;&nbsp;
       <Select v-model="bl_dept_id" placeholder="请选择部门名称" style="width:300px;margin-right: 10px;" :clearable="true"
          @on-change="departmentChange">
          <Option v-for="(item,index) in DepartMentList" :key="index" :value="item.dept_id">
            {{item.dept_cn_name}}
          </Option>
        </Select>
      </div>
      <div>
        <Button class="ys-confirm" v-if="hasPerm('org_deprole_Add') == 2" icon="ios-add"
          @click="handleAddClick">新建</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :total="totalCount" :current="pageNumber" :page-size="pageSize" @on-change="handlePagingClick" />
    </div>
    <!-- 新增/编辑弹框 -->
    <AddDepartRoleModal :IsOpenModal="IsOpenModal" :operationType="operationType" :DepartMentList="DepartMentList"
      :DepartRoleTypeList="DepartRoleTypeList" :EditDepartRoleInfo="EditDepartRoleInfo" @on-handleClick="handleClick">
    </AddDepartRoleModal>
    <!-- 二次确认框 -->
    <Alter ref="AlterModal" :configData="AlterConfigData" @change_ok="DeleteDepartRole(EditDepartRoleInfo.dprl_code)">
    </Alter>
    <!-- 权限弹框 -->
    <jurisdiction-model :popoutType="2" :explainInfo="explainInfo" :MenuPermissionList="MenuPermissionList"
      :currentStatus="currentStatus" @on-jurisdiction-click="onJurisdictionClick"
      @selectedPermissionList="selectedPermissionList">>
    </jurisdiction-model>
  </div>
</template>
<script>
  import {
    mapActions,
    mapGetters
  } from "vuex"
  import JurisdictionModel from '_g/commonComponent/jurisdictionModel'; // 权限配置弹框
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js'
  import AddDepartRoleModal from "../components/AddDepartRoleModal"
  import {
    sys_getMenuPermission,
    sys_setMenuPermissionBydeprole
  } from "@/utils/sys_utils/pulicServer"
  export default {
    components: {
      'el-table': ElTable,
      AddDepartRoleModal,
      'jurisdiction-model': JurisdictionModel
    },
    data() {
      return {
        tableData: [], // 数据
        Columns: [], // 表头
        totalCount: 0, // 总条数
        pageNumber: 1, // 当前页码
        pageSize: 12, // 每页显示条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        IsOpenModal: false, //是否打开弹框
        operationType: 1, // 操作类型 1新增  2编辑
        EditDepartRoleInfo: {}, //要编辑/删除的部门角色信息
        AlterConfigData: {}, //二次弹框配置数据
        selNowEnterId: "", // 当前选择的企业ID
        DepartMentList: [], // 当前企业下的所有部门列表
        DepartRoleTypeList: [], // 当前企业下的所有部门角色类型列表
        // 权限配置相关变量
        explainInfo: {}, // 权限配置弹框头部基础信息
        MenuPermissionList: [], // 菜单权限数据列表
        currentStatus: false, // 打开权限列表弹框
        tableLoading: true, // 表格loading
        bl_dept_id: '', // 部门筛选的字段
      }
    },
    created() {
      this.getEnterListInit();
    },
    computed: {
      ...mapGetters(["getEnterpriseList"])
    },
    methods: {
      ...mapActions([
        "PageExtDprlListAction", 
        "DpDeptView_qryDpDeptAllByDeptId", 
        "AddDprlAction",
        "ConfigCodeView_qryConfigByType", 
        "DeleteDprlAction", 
        "UpdateDprlAction",
        "QueryAllRoleAction_querySubordinateRoles",
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("roleWrapper"), (element) => {
          _this.tableHeight = (element.scrollHeight - 66 - 90);
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        switch (options.code) {
          case 0: // 配置权限
            this.explainInfo = rowItem;
            this.getPermissionInfo({
              type_code: 'role', // 部门角色类型
              dprl_code: rowItem.dprl_code, // 部门角色ID
              cull_type: "cull",
              ent_no: this.selNowEnterId, // 所属企业ID
            });
            // 每次请求都需要清除原来数据 
            this.MenuPermissionList = [];
            this.currentStatus = true;
            break;
          case 1:
            this.operationType = 2;
            this.EditDepartRoleInfo = JSON.parse(JSON.stringify(rowItem));
            this.IsOpenModal = true;
            break;
          case -1:
            this.EditDepartRoleInfo = rowItem;
            this.AlterConfigData = {
              type: "warning",
              title: "警告",
              content: "是否确认删除当前企业信息？"
            }
            this.$refs.AlterModal.OpenModal();
            break;
          default:
            break;
        }
      },
      // 新建功能
      handleAddClick() {
        this.operationType = 1;
        this.IsOpenModal = true;
      },
      // 搜索功能
      handleSearchClick() {},
      // 分页功能
      handlePagingClick(pageNumber) {
        this.pageNumber = pageNumber;
        this.QueryDepaetRoleList(pageNumber);
      },
      // 弹框操作功能
      handleClick(index, info = null) {
        // 取消
        if (index === 1) {
          this.IsOpenModal = false;
          return;
        } else {
          if (info && info.dprl_code) {
            // 编辑
            let params = {
              dprl_code: info.dprl_code,
              bk_expl: info.bk_expl
            }
            this.UpdateDepartRole(params);
          } else {
            // 保存
            this.CreateDepartRole(info);
          }
        }
      },
      // 所属部门查询
      async listDeptsByNameActions(id) {
        try {
          const data = await this.listDeptsByNameAction({
            ent_id: id
          });
          if (data.request_state) {
            this.departmentList = data.dpDeptInfoList;
          }
        } catch (error) {
          this.$Message.error(error);
        }
      },
      // 配置权限弹框回调
      onJurisdictionClick(res) {
        this.currentStatus = false;
      },
      //****************** 接口服务 ********************************
      // 初始化查询  根据企业ID查询列表
      getEnterListInit() {
        // 默认选择第一个企业
        this.$nextTick(() => {
          if (this.getEnterpriseList && this.getEnterpriseList.length > 0) {
            this.selNowEnterId = this.getEnterpriseList[0].dept_id;
            // 获取列表数据
            this.QueryDepaetRoleList();
            // 获取部门列表
            this.QueryDepartListByEnterpId();
            // 获取部门角色类型列表
            this.QueryDepartRoleTypeListByEnterpId();
          }
        });
      },
      //查询部门角色列表 enterpId 企业ID
      QueryDepaetRoleList(pageNumber = 0, deptName = null) {
        this.tableLoading = true;
        pageNumber = pageNumber <= 0 ? 0 : pageNumber - 1;
        let params = {
          ent_no: this.selNowEnterId, // 重写企业ID
          dept_id: this.selNowEnterId, // 所属企业ID
          start_recd: pageNumber * this.pageSize, // 从第几条开始查询
          limit_recd: this.pageSize, // 每页显示多少条
          dept_cn_name: deptName == null ? "" : deptName, //模糊查询 部门角色名称
          bl_dept_id: this.bl_dept_id
        }
        this.PageExtDprlListAction(params).then(res => {
          const {
            request_state,
            dprl_list,
            all_recd
          } = res;
          if (request_state) {
            this.totalCount = all_recd; // 总条数 
            this.tableData = dprl_list; // 获取当前分页数据
            this.tableLoading = false;
          }
        }).catch(err => {
          this.$Message.error(err);
          this.tableLoading = false;
        })
      },
      // 根据企业ID查询部门列表
      QueryDepartListByEnterpId() {
        this.DpDeptView_qryDpDeptAllByDeptId({
          dept_id: this.selNowEnterId
        }).then(res => {
          let {
            request_state,
            dpDeptInfoList
          } = res;
          if (request_state) {
            this.DepartMentList = dpDeptInfoList;
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      // 创建部门角色
      CreateDepartRole(departRoleInfo) {
        this.AddDprlAction(departRoleInfo).then(res => {
          let {
            request_state
          } = res;
          if (request_state) {
            this.IsOpenModal = false;
            this.pageNumber = 1;
            this.$Message.success("新增部门角色成功！");
            // 重新查询数据
            this.QueryDepaetRoleList();
          } else {
            this.$Message.error(res.message_text);
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      // 根据企业ID获取部门角色类型数据列表
      QueryDepartRoleTypeListByEnterpId() {
        this.QueryAllRoleAction_querySubordinateRoles().then(res => {
          let {
            request_state,
            role_list
          } = res;
          if (request_state) {
            this.DepartRoleTypeList = role_list ? role_list : [];
          } else {
            this.$Message.error("获取角色类别数据源失败！");
          }
        }).catch(err => {
          this.$Message.error(err);
        })
        // this.ConfigCodeView_qryConfigByType({
        //   type_code: "roles",
        //   // emt_id: this.selNowEnterId
        // }).then(res => {
        //   let {
        //     request_state,
        //     config_list
        //   } = res;
        //   if (request_state) {
        //     this.DepartRoleTypeList = config_list ? config_list : [];
        //   } else {
        //     this.$Message.error("获取企业类型数据源失败！");
        //   }
        // }).catch(err => {
        //   this.$Message.error(err);
        // })
      },
      // 切换企业
      enterpListChange(enterpID) {
        this.pageNumber = 1;
        this.selNowEnterId = enterpID;
        this.QueryDepaetRoleList();
        // 获取部门列表
        this.QueryDepartListByEnterpId();
        // 获取部门角色类型列表
        // this.QueryDepartRoleTypeListByEnterpId();
      },
      // 切换部门名称
      departmentChange() {
        this.pageNumber = 1;
        this.QueryDepaetRoleList();
      },
      // 删除部门角色
      DeleteDepartRole(EnterpriseID) {
        this.DeleteDprlAction({
          dprl_code: EnterpriseID
        }).then(res => {
          let {
            request_state
          } = res;
          request_state && this.$Message.success("删除部门角色成功！");
          this.pageNumber = 1;
          this.QueryDepaetRoleList();
        }).catch(err => {
          this.$Message.error("删除部门角色失败！")
        })
      },
      // 编辑部门角色
      UpdateDepartRole(params) {
        this.UpdateDprlAction(params).then(res => {
          let {
            request_state
          } = res;
          this.pageNumber = 1;
          request_state && this.$Message.success("编辑部门角色成功！");
          this.IsOpenModal = false;
          this.pageNumber = 1;
          this.QueryDepaetRoleList();
        }).catch(err => {
          this.$Message.error("编辑部门角色失败！")
        })
      },
      // 获取权限数据信息
      getPermissionInfo(params) {
        sys_getMenuPermission(params).then(res => {
          if (res) {
            this.MenuPermissionList = res;
          }
        }).catch(err => {
          this.$Message.error(err);
        })
      },
      // 保存配置的权限数据
      selectedPermissionList(menuList, BtnList) {
        // 如果返回菜单权限
        if (menuList) {
          let params = {
            dprl_code: this.explainInfo.dprl_code, //当前部门角色ID
            rs_ary: menuList,
            opt_priv: []
          }
          sys_setMenuPermissionBydeprole(params).then(res => {
            if (res) {
              this.$Message.success("权限配置成功！")
            }
          }).catch(err => {
            this.$Message.error(err);
          })
        }
      },
    },
    mounted() {
      this.Columns = Columns;
      // 获取元素高度
      this.getElementHeight();
    },
    watch: {
      getEnterpriseList() {
        this.getEnterListInit();
      }
    }
  }
</script>
<style lang="less" scoped>
  #roleWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;
    overflow: hidden;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>